import React, { useState } from "react";

import BigRAD from "./components/BigRAD";
import PrintableRAD from "./components/PrintableRAD";
import { Bar, ButtonGroup } from "@cadenza/ui";
import RADShapes from "../RADDrawing/RADShapes.jsx";

import RADZoomControls from "./components/ZoomControlsI18n";
import { UndoRedoController } from "@cadenza/history-react";
import { FullScreenButtonI18n } from "@cadenza/i18n-wrappers";

import { useRADDispatch } from "../RADHandler/contexts/RADDispatchContext.jsx";
import { useRADSelection } from "../RADHandler/contexts/RADSelectionContext.jsx";
import { useRADEvents } from "../RADHandler/contexts/RADEventContext.jsx";

const RADLayout = () => {
  const { state: rad, updatePosition } = useRADDispatch();
  const { onBackgroundClick, onClick } = useRADEvents();
  const { selectedComponent, isConnecting, isLooping, isMerging, showTargets } =
    useRADSelection();

  const [zoomApi, setZoomApi] = useState(null);

  const zoomContent = (
    <RADZoomControls
      onZoomIn={() => zoomApi?.zoomIn()}
      onZoomOut={() => zoomApi?.zoomOut()}
      onReset={() => zoomApi?.resetZoom()}
      onFit={() => zoomApi?.zoomToFit()}
      setScale={(v) => zoomApi?.setScale(v)}
      currentScale={zoomApi?.currentScale ?? 1}
      minScale={zoomApi?.minScale ?? 0.1}
      maxScale={zoomApi?.maxScale ?? 3}
    />
  );

  const rightContent = (
    <ButtonGroup>
      <FullScreenButtonI18n elementId={"rad-handler"} />
      <BigRAD
        Component={PrintableRAD}
        componentProps={{
          rad,
          diagramClass: "rad-diagram-container",
          dragEnabled: false, // disable drag/edit for the big view
          onBackgroundClick,
          onClick,
          updatePosition, // harmless when dragEnabled=false
          selectedComponent,
          isConnecting,
          isLooping,
          isMerging,
          showTargets,
        }}
      />
    </ButtonGroup>
  );

  const leftContent = <UndoRedoController />;

  const centreContent = <RADShapes />;

  return (
    <div id="rad-display" className="rad-shell">
      <Bar
        className="rad-bar"
        leftContent={leftContent}
        centreContent={zoomContent}
        rightContent={rightContent}
      />
      <Bar
        leftContent={null}
        centreContent={centreContent}
        rightContent={null}
      />
      <div className="rad-content">
        <PrintableRAD
          rad={rad}
          diagramClass="rad-diagram-container"
          dragEnabled={true}
          onBackgroundClick={onBackgroundClick}
          onClick={onClick}
          handleMove={updatePosition}
          selectedComponent={selectedComponent}
          isConnecting={isConnecting}
          isLooping={isLooping}
          isMerging={isMerging}
          showTargets={showTargets}
          onZoomApi={setZoomApi}
        />
      </div>
    </div>
  );
};

export default RADLayout;
